import { Device, from } from '@helpers/media';
import useMedia from '@hooks/useMedia';
import CtaCard from '@stories/Components/Cards/CtaCard/CtaCard';
import * as React from 'react';
import S from './CtaCards.styles';
const CtaCards = (props) => {
    const [contentHeight, setContentHeight] = React.useState(0);
    const count = props.intro ? props.items.length + 1 : props.items.length;
    const ItemRef = React.useRef(null);
    const isDesktop = useMedia([from(Device.DesktopSmall)], [true], false);
    const paddingBase = isDesktop ? 80 : 45;
    React.useEffect(() => {
        setContentHeight(ItemRef.current?.children[0].children[1].clientHeight);
    }, [ItemRef]);
    React.useEffect(() => {
        window.addEventListener('resize', () => setContentHeight(ItemRef.current?.children[0].children[1].clientHeight), { passive: true });
        return () => {
            window.removeEventListener('resize', () => setContentHeight(ItemRef.current?.children[0].children[1].clientHeight));
        };
    }, []);
    return (React.createElement(S.Container, { id: props.anchorId },
        props.background && (React.createElement(S.Bg, { style: {
                height: `calc(${contentHeight}px + ${paddingBase}px + 16px)`,
                bottom: `-${paddingBase - (count > 3 && count === 2 ? 28 : 0)}px`,
            } })),
        !props.intro && (React.createElement(S.Header, null,
            React.createElement(S.Title, { ...(props.titleType && props.titleType === 'h1' ? { as: 'h1' } : {}) }, props.title))),
        React.createElement(S.Body, null,
            React.createElement(S.List, { "data-columns": count % 3 === 0 ? 3 : count % 2 === 0 || count < 3 ? 2 : 3 },
                props.intro && (React.createElement(S.Item, null,
                    React.createElement(S.ContentInner, null,
                        React.createElement(S.Title, { ...(props.titleType && props.titleType === 'h1' ? { as: 'h1' } : {}) }, props.title),
                        React.createElement(S.Content, null, props.intro)))),
                props.items.map((item) => (React.createElement(S.Item, { ref: ItemRef, key: item.id },
                    React.createElement(CtaCard, { ...item, imageShape: props.imageShape, buttonStyle: props.buttonStyle, translations: props.translations }))))))));
};
export default CtaCards;
